import { CardProps, Input } from "@dune/ui";
import { formatDateForInput } from "@dune/utils";

interface DatesDetailsContainerProps extends CardProps {
	receptionDate?: Date;
	startDate?: Date;
	cityHallStartDate?: Date;
}

const ReceptionDatesDetailsContainer = ({
	startDate,
	receptionDate,
	cityHallStartDate,
	...cardProps
}: DatesDetailsContainerProps) => {
	return (
		<div
			className="flex flex-col border-solid border-1 border-gray-200 rounded-lg p-4 gap-4"
			{...cardProps}
		>
			<div className="flex flex-row gap-4">
				<div className="flex flex-col gap-2 w-full">
					<Input
						label="Début des travaux"
						value={formatDateForInput(startDate?.toString())}
						type="date"
						disabled
					/>
				</div>

				<div className="flex flex-col gap-2 w-full">
					<Input
						value={formatDateForInput(receptionDate?.toString())}
						label="Date de réception"
						type="date"
						disabled
					/>
				</div>
			</div>
			<div className="flex flex-row gap-2 w-full">
				<div className="flex items-center gap-4 w-full">
					<Input
						label="Déclaration d'ouverture de chantier"
						disabled
						value={formatDateForInput(cityHallStartDate?.toString())}
						type="date"
					/>
				</div>
			</div>
		</div>
	);
};

export default ReceptionDatesDetailsContainer;
